import { Button, Modal } from "react-bootstrap";
import { useState } from "react";
import { useMerchant } from "../context/merchant";

export default function TimePickerModal({
  orderId,
  show,
  handleClose,
  handleUpdateStatus,
  loading,
}) {
  const { isFullScreen } = useMerchant();
  const prepMins = [10, 15, 20, 25, 30, 35, 40, 45, 50];
  const [minIndex, setMinIndex] = useState(null);

  const handlePressSelect = () => {
    if (minIndex === null) {
      console.error("No duration selected.");
      return;
    }

    const selectedSeconds = prepMins[minIndex] * 60; // минут → секунд
    // Сервер prepStartedAt/prepDuration бичнэ; дараагийн poll prepRemainingSec өгнө.
    // localStorage бичихгүй (аль ч төхөөрөмжид зөв харагдана).
    handleUpdateStatus(3, selectedSeconds);
    handleClose();
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      backdrop
      className="blurred"
    >
      <Modal.Header closeButton className="bg-danger">
        <p className={`${isFullScreen ? "h3" : "h4"} header-title text-white`}>
          Бэлдэх хугацаа сонгох
        </p>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex align-items-center flex-wrap gap-2">
          {prepMins.map((el, i) => (
            <button
              key={i}
              type="button"
              className={`btn ${
                i !== minIndex ? "btn-outline-dark" : "btn-dark"
              } col ${isFullScreen && "fs-4"}`}
              onClick={() => {
                minIndex === i ? setMinIndex(null) : setMinIndex(i);
              }}
            >
              {el} <br /> минут
            </button>
          ))}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div
          className={`btn btn-outline-danger ${isFullScreen && "btn-lg"}`}
          onClick={handleClose}
        >
          Болих
        </div>
        <Button
          className={isFullScreen && "btn-lg btn-primary"}
          onClick={handlePressSelect}
          disabled={minIndex === null || loading}
        >
          {loading ? (
            <span
              className="spinner-border spinner-border-sm mx-3"
              role="status"
              aria-hidden="true"
            />
          ) : (
            `Сонгох`
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
